import { USER_ID_STORAGE_KEY } from './constants';
import { storage } from './utility/storage';
import uuid from './utility/uuid';

// ref. https://github.com/wilmoore/uuid-regexp.js/blob/674d65e5e371d7c126a58a09281e8e21ee503e9a/regexp.js#L14
export const validIdfvRegexp = /^[a-f0-9]{8}-?[a-f0-9]{4}-?[1-5][a-f0-9]{3}-?[89ab][a-f0-9]{3}-?[a-f0-9]{12}$/i;

export class Idfv {
  public readonly value: string;

  public constructor(value?: string) {
    this.value = value || storage.get(USER_ID_STORAGE_KEY) || uuid();
  }

  public isValid(): boolean {
    return validIdfvRegexp.test(this.value);
  }

  public recover(): Idfv {
    const current = this.value;

    // 特定のサイトで、Cookieに保存した idfv の値に ::kddicsa_ から始まる文字列が付くことがある。
    // それを検知したとき、その文字列を取り除いて正しい値にリカバリーする
    // ref. https://repro.esa.io/posts/35590
    if (current.indexOf('::kddicsa_') > -1) {
      const recovered = current.substr(0, current.indexOf('::kddicsa_'));
      return new Idfv(recovered);
    }
    // 特定のサイトにおいてなぜかCookieに保存した idfv の値が Base64化されたような文字列となることがある。
    // 原因は不明だがサイト固有のJSによって実施されている可能性が高く、リカバリー不能のため idfv を再生成する。
    // なお厳密にBase64であるかどうかのチェックも可能だが、UUIDの形式に則っていない時点で不正のため、簡易的なチェックとしている。
    if (current.endsWith('=')) {
      return new Idfv(uuid());
    }

    // TODO: ここで ::kddicsa_ や Base64 とは関係なくidfvが正規のパターンではない場合全般のリカバリー処理を入れる
    //       その場合は単にUUID再生成する。
    // 補足: なぜ現時点で↑の実装になっていないかというと、kddicsa以外の壊れ方をしている場合がどれくらいあるか観測できていないため、
    // 実装すると予想外の影響が出てしまう可能性があるため。UUIDが他の壊れ方をするケースがどれくらいあるのか把握してから実装すべし

    return this;
  }
}
